import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Heart } from "lucide-react";
import { Bow, FourPointStar } from "@/components/Sparkles";

const LOGO =
  "https://customer-assets.emergentagent.com/job_andrews-pink-co/artifacts/c2dqbyuo_icm_fullxfull.893442695_cpvpdh1kpncc4cokk0ws.jpg";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative mt-16 overflow-hidden bg-blush text-plum"
      data-testid="site-footer"
    >
      <div
        className="absolute -top-10 left-10 rotate-12 opacity-40"
        aria-hidden
      >
        <Bow size={120} color="#ffc6dd" />
      </div>
      <div
        className="absolute bottom-10 right-20 opacity-50"
        aria-hidden
      >
        <FourPointStar size={28} fill="#ff3ea5" />
      </div>

      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-3" data-testid="footer-logo">
            <img
              src={LOGO}
              alt="Uniquely Pink"
              className="h-14 w-14 rounded-full ring-2 ring-hotpink/40"
            />
            <span className="font-script text-4xl text-hotpink">
              Uniquely Pink
            </span>
          </Link>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-roseslate">
            A pink-only boutique in Andrews, Texas. Girly gifts, accessories,
            and pink must-haves chosen with love for anyone who believes life
            is better in pink.
          </p>
          <p className="mt-4 flex items-center gap-2 text-sm font-medium text-magenta">
            <MapPin className="h-4 w-4" /> Andrews, Texas
          </p>
        </div>

        <div>
          <h4 className="font-subheading text-lg text-magenta">Shop</h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <Link
                to="/shop"
                className="hover:text-hotpink"
                data-testid="footer-link-shop"
              >
                All Products
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:text-hotpink"
                data-testid="footer-link-about"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-hotpink"
                data-testid="footer-link-contact"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-subheading text-lg text-magenta">Help</h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <Link
                to="/policies#shipping"
                className="hover:text-hotpink"
                data-testid="footer-link-shipping"
              >
                Shipping
              </Link>
            </li>
            <li>
              <Link
                to="/policies#returns"
                className="hover:text-hotpink"
                data-testid="footer-link-returns"
              >
                Returns
              </Link>
            </li>
            <li>
              <Link
                to="/policies#privacy"
                className="hover:text-hotpink"
                data-testid="footer-link-privacy"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/policies#terms"
                className="hover:text-hotpink"
                data-testid="footer-link-terms"
              >
                Terms
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-hotpink/15">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-roseslate sm:flex-row sm:px-6 lg:px-8">
          <p>
            &copy; {year} Uniquely Pink. All things pink, made with{" "}
            <Heart className="inline h-3 w-3 fill-hotpink text-hotpink" /> in
            Andrews, Texas.
          </p>
          <p>Pink-only boutique &middot; Girly gifts &middot; Accessories</p>
        </div>
      </div>
    </footer>
  );
}
